module.exports = __webpack_public_path__ + "img/target_symbol_green.613f104c.svg";